import { FormControl, TextField } from "@mui/material";
import { default as React, useEffect } from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      marginLeft: 0,
      marginRight: 0,
      width: "100%",
    },
  })
);

export interface Form0x28800000 {
  modbus: number;
  fileName: string;
}

export function Command0x28800000(props) {
  const classes = useStyles();
  const { value, handleChange } = props;

  const commandForm = {
    modbus: 0,
    fileName: "",
  };

  const [fields, setFields] = React.useState<Form0x28800000>(commandForm);

  const handleChangeField =
    (prop: keyof Form0x28800000) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      handleChange(JSON.stringify({ ...fields, [prop]: event.target.value }));
    };

  useEffect(() => {
    const params = JSON.parse(value);

    if (!params.modbus) {
      params.modbus = 0;
    }
    if (!params.fileName) {
      params.fileName = "";
    }

    setFields(params);
  }, [value]);

  return (
    <>
      <FormControl className={classes.formControl}>
        <TextField
          type="number"
          inputProps={{ min: 0 }}
          id="modbus"
          label="Адрес Modbus БВВ, который нужно обновить (0 - нужно обновить прикладное ПО ПЛК)"
          margin="dense"
          fullWidth
          value={fields.modbus}
          onChange={handleChangeField("modbus")}
        />
      </FormControl>

      <FormControl className={classes.formControl}>
        <TextField
          id="fileName"
          label="Имя файла"
          margin="dense"
          fullWidth
          value={fields.fileName}
          onChange={handleChangeField("fileName")}
        />
      </FormControl>
    </>
  );
}
